module.exports = __webpack_public_path__ + "media/fonts/american_typewriter-webfont-4fddbd9745dd1b653405ccc11e10c485.woff";